import {
  Component,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  Renderer2,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'app-select-dropdown',
  templateUrl: './select-dropdown.component.html',
  styleUrl: './select-dropdown.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SelectDropdownComponent {
  @Input() placeholder: any;
  @Input() optionList: any = [];
  @Input() label: any;
  @Input() value: any;
  @Input() clear: boolean = false;
  @Output() onChange = new EventEmitter<any>();
  SelectLabel: any;
  valueChanged: boolean = false;

  selectdropdown(data: any) {
    this.valueChanged = true;
    this.SelectLabel = data[this.label];

    this.onChange.emit(data);
  }
}

@Directive({
  selector: '[selectExpand]',
  standalone: false,
})
export class SelectDropdownDirective {
  constructor(
    private readonly eleRef: ElementRef,
    private readonly renderer: Renderer2,
  ) {}

  @HostListener('click') toggleClick() {
    if (this.eleRef.nativeElement.classList.contains('active')) {
      this.renderer.removeClass(this.eleRef.nativeElement, 'active');
      this.renderer.removeClass(
        this.eleRef.nativeElement.childNodes[1],
        'active',
      );
    } else {
      this.renderer.addClass(this.eleRef.nativeElement, 'active');
      this.renderer.addClass(this.eleRef.nativeElement.childNodes[1], 'active');
    }
  }

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: EventTarget | null): void {
    if (!targetElement) {
      return;
    }

    const clickedInside = this.eleRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.renderer.removeClass(this.eleRef.nativeElement, 'active');
      this.renderer.removeClass(
        this.eleRef.nativeElement.childNodes[1],
        'active',
      );
    }
  }
}
